import {View} from 'backbone';
import template from 'common-views/select-item.ejs';
import constants from 'Constants.js';
import $ from 'jquery';
import Spinner from 'spin/spin';
import zLib from 'util/ZLib.js';


class SelectItemModalView extends View {
    
    initialize(opts){
        this.infiniteScrolling = opts.model.attributes.infiniteScrolling ? opts.model.attributes.infiniteScrolling : false;
        this.currentPage = 1; // Initialize page number
        this.total = 0; // To save total of items
        this.limit = 500; // In case of msi
        this.filtered = false; // To save if its a filtered list
       

        super.initialize(opts);
        if (!this.model.get('subtitle')) {
            this.model.set('subtitle',  'Please Select One');
        }

        // PF-5852
        // Configure infinite scrolling only if required
        if (this.infiniteScrolling) {
            this.limit = constants.INFINITE_SCROLL_ITEMS; // Get limit per page
        }   

        this.spinner = opts.spinner || new Spinner();
        this.mappedUsers = opts.mappedUsers || false;
        this.width = opts.model.get('width');
        this.events = {
            'change #filterList' : 'filterList'
        };


        $('body').append(this.$el);
    }
    itemSelected(e){
        e.preventDefault();
        const
            targetIndex = e.currentTarget.getAttribute('data-index'),
            items = this.model.get('items');

        let multiSelectionKeyPressed, itemArray;
        if (e.metaKey || e.ctrlKey) {
            multiSelectionKeyPressed = 'ctrl';
        } else if (e.shiftKey) {
            multiSelectionKeyPressed = 'shift';
        }
            
        if (this.model.get('multipleSelectionEnabled') && multiSelectionKeyPressed) {
            itemArray = this.model.get('selectedItem');
            let existItemOnModel = false;
            const item = { id: items[targetIndex].listType, name: items[targetIndex].label};
            if (!itemArray) {
                itemArray = [];
            } else {
                if (!$.isArray(itemArray)){
                    itemArray = [itemArray];
                }

                if (itemArray.find((x) => x['@id'] === item.id)) {
                    existItemOnModel = true;
                }
            }

            if (!existItemOnModel) {
                itemArray.push(items[targetIndex]);
            }

            let limitsForShiftSel = this.model.get('limitsForShiftSel');
            if (!limitsForShiftSel){
                limitsForShiftSel = [];
            }

            if (multiSelectionKeyPressed === 'ctrl' || itemArray.length <= 1) {            
                $(e.currentTarget).toggleClass('selected');
                if (!$(e.currentTarget).hasClass('selected')){ //If it was a de-selection then remove item from array
                    itemArray = itemArray.filter(f => f['listType'] !== item['id']); 
                }

                limitsForShiftSel[0] = parseInt(targetIndex);
                this.model.set('limitsForShiftSel', limitsForShiftSel, { silent: true });
            } else {
                //Will count to two, one for inferior limit and another for superior limit
                if (limitsForShiftSel[0] > parseInt(targetIndex)){
                    limitsForShiftSel[1] = limitsForShiftSel[0];                    
                    limitsForShiftSel[0] = parseInt(targetIndex);
                }else{                    
                    limitsForShiftSel[1] = parseInt(targetIndex);
                }

                let newArray = [];
                $('#dialog').find('ul.select-list').find('a.item').each(function (index, _itemSelected) {
                    $(_itemSelected).removeClass('selected');
                    let _selIndex = parseInt($(_itemSelected).data('index'));
                    if (_selIndex >= limitsForShiftSel[0] && _selIndex <= limitsForShiftSel[1]){                        
                        $(_itemSelected).addClass('selected');
                        const newItem = items[_selIndex];
                        newArray.push(newItem);
                    }
                });

                limitsForShiftSel[0] = limitsForShiftSel[1];

                this.model.set("limitsForShiftSel", limitsForShiftSel, { silent: true });
                itemArray = newArray;
            }

            this.model.set('selectedItem', itemArray, { silent: true });
        } else {
            itemArray = [ items[targetIndex] ];
            this.model.set('selectedItem', items[targetIndex]);
            this.model.set('selectedIndex', targetIndex);
            $('#dialog').find('ul.select-list').find('a.selected').removeClass('selected');
            $(e.currentTarget).addClass('selected');

            if (this.model.get('multipleSelectionEnabled')){ //Keep track of last item selected   
                let limitsForShiftSel = this.model.get('limitsForShiftSel');
                if (!limitsForShiftSel){
                    limitsForShiftSel = [];
                }
                limitsForShiftSel[0] = parseInt(targetIndex);
                this.model.set("limitsForShiftSel", limitsForShiftSel, { silent: true });
            }
        }
        
        if (itemArray && itemArray.length > 0){
            $('button.btn-select-item').button("enable");
        }else{
            $('button.btn-select-item').button("disable");
        }
    }

    filterList() {
        const filter = $('#filterList').val().toUpperCase();
        const filteredList =  $("#filteredListModal"), allElements = $("#allListModal");

        this.spinner.spin($(constants.CONTENT_ID).get(0));
        setTimeout(()=>{
            // If infinite scrolling is enabled
            if (this.infiniteScrolling) {
                // Set page to 1
                this.currentPage = 1;
                // Clear list of all elements
                allElements.empty();
            }
            

            filteredList.empty();
            const itemsToFilter = this.model.get("items");

            if(filter !== ""){
                this.filtered = true;
                // Get filtered items
                this.items = itemsToFilter.filter(item => item.label.toUpperCase().includes(filter));
                 

                // PF-5852 Load filtered/all items
                this.loadItems(document.getElementById('filteredListModal'), this.items);
                filteredList.find('.item').on('click', e => this.itemSelected(e));
               
                // Show filtered list
                filteredList.show();
                // Hide all element list
                allElements.hide();
               
            }else{
                // Set filtered to false
                this.filtered = false;
                // If infinite scrolling is enable
                if (this.infiniteScrolling) {
                    // Load items in all list modal
                    this.loadItems(document.getElementById('allListModal'), this.items);
                    allElements.find('.item').on('click', e => this.itemSelected(e));
                }
                // Hide filteredList
                filteredList.hide();
                // Show all element list
                allElements.show();
            }       

            

            this.spinner.stop();
        }, 1000);

      
    }

    loadItems(list, items){
        let maxItems = items.length;
        this.total = maxItems;

        $('#warn-users-max-shown').hide();

        //PF-5852 MSIE message not needed because only render n elements each time
        if (!this.infiniteScrolling && (items.length > 500 && (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1))){
            maxItems = 500;
            $('#warn-users-max-shown').html(constants.ITEM_SEARCH_LIMIT_EXCEEDED_TEXT);
            $('#warn-users-max-shown').show();
        }

        // First load, limited to n items
        let endItems = !this.infiniteScrolling ? maxItems :
                        this.limit > maxItems ? maxItems : this.limit;

        for (let i = 0; i < endItems; i++) {               
            this.createElement(items[i], i, list);          
        }
        
        this.spinner.stop();
    }

    createElement (element, i, list) {
        let item = document.createElement("li");
        let anchor = document.createElement("a");
        anchor.className = "item";
        anchor.href = "#";
        anchor.text = element.label ? element.label : constants.USER_NAME_NOT_DEFINED_TEXT;
        if (!element.targetIndex){ //Filtered elements must have the same target-index as the full list in order for selection to work
            element.targetIndex = i;
        }
        anchor.setAttribute("data-index", element.targetIndex);
        
        item.setAttribute("data-type", element.listType);
        item.appendChild(anchor);
        
        list.appendChild(item);
    }

    // PF-5852 function to know if there are more items to show in infinite scroll
    hasMoreItems () {
        const startIndex = this.currentPage * this.limit;
        return startIndex < this.total;
    }

    // load more items
    loadMoreItems () {
        // If don't are more items exit method
        if (!this.hasMoreItems()) {
            return;
        }

        this.spinner.spin();
        
        let list = this.filtered ? document.getElementById('filteredListModal') : document.getElementById('allListModal');
        let listClick = this.filtered ? $('#filteredListModal') : $('#allListModal');
        try {

            // get next items
            let startIndex = this.limit * this.currentPage;
            let endIndex = startIndex + this.limit;
            // If end index is higher than max items
            if (endIndex >= this.items.length) {
                // Set end index as length of items
                endIndex = this.items.length;
            }
            // Create new elements
            for (let i = startIndex; i < endIndex; i++) {      
                this.createElement(this.items[i], i, list);  
            }

            listClick.find('.item').slice(startIndex).on('click', e => this.itemSelected(e));

            // Increase currentPage
            this.currentPage++;
        } catch (error) {
            console.log(error.message);
        } finally {
            this.spinner.stop();
        }
    }

    render(){
        return new Promise((resolve, reject) => {

            this.$el.html(template(this.model.toJSON()));
           
            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 250,
                width: this.width || 320,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'OK',
                        'class':'btn-select-item',
                        disabled: true,
                        click: () => {
                            resolve(this.model.get('selectedItem'));
                            this.closeModal();
                        }
                    },  
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve();
                            this.closeModal();
                        }
                    }
                ],               
                close: () => {
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        
            setTimeout( () => {

                if (!this.mappedUsers) {
                    let items = this.model.get("items");

                    for (var i = 0, len = items.length; i < len; i++) { //Filtered elements must have the same target-index as the full list in order for selection to work
                        items[i].targetIndex = i;
                    }
                }
                // Set items as all items
                this.items =  this.model.get("items");
                this.loadItems(document.getElementById('allListModal'), this.items);
                this.bindEvents();
            }, 100);
        });
    }
    bindEvents(){
        const self = this;

        $('#dialog').find('.item').on('click', e => this.itemSelected(e));
       
        $('#filterList').on('keyup', function(e) {
            //Add timeout to allow the key to be rendered in the input box and the spinner to be displayed
            if (this.searchDelayTimer){
                clearTimeout(this.searchDelayTimer);
            }

            this.searchDelayTimer = setTimeout( () => {               
                self.filterList();
            }, 1000);           
        });

        const container = $("#dialog")[0];  
        if (this.infiniteScrolling && container) {
            container.addEventListener('scroll', () => {
                const {
                    scrollTop,
                    scrollHeight,
                    clientHeight
                } = container;
        
                if (scrollTop + clientHeight >= scrollHeight - 5 
                    && this.hasMoreItems(this.currentPage, this.limit, this.total)) {
                        this.loadMoreItems();
                }
            }, {
                passive: true
            });
        }
        

    }
    unbindEvents(){
        $('#dialog').find('.item').unbind();
    }
    closeModal(){
        $( constants.DIALOG_ID ).dialog("destroy").remove();
    }
}

export default SelectItemModalView;